module.exports = __webpack_public_path__ + "img/star-dark.7a22e147.svg";